// Canonical host for the server-served media the app links to by absolute URL
// (product photos under /mto/, salesman images under /assets/).
//
// These used to be built from "https://www.popinweddingdesigner.com". That www
// host does not resolve, so every image built from it failed to load: the item
// grid showed a broken-image icon instead of the captured product photo, and
// the photo boxes on printed slips came out empty. The site — and the origin
// capacitor.config.ts gives the native WebView — is the bare domain.
//
// Customer pictures stay on the `popin.` image sub-domain and are NOT covered
// by this constant.
export const MEDIA_HOST = 'https://popinweddingdesigner.com'

// The legacy picture sub-domain. It holds the catalogue/desktop-system images
// (PM_P_1_*, EC_*, ES_*, RC_*, EP_1_*, company C_*/CO_* …).
//
// NOT everything under /Pictures/ lives here. Photos captured in this app go
// through /api/admin/upload-measurement-image, which writes them into the
// Laravel site's own public/Pictures — so the measurement photos
// (C_/T_/B_/P_/F_ + measurement id) are served by MEDIA_HOST, not this host.
// Anything printing a /Pictures/ path must therefore be prepared to try both;
// see pictureUrlCandidates() in utils/printHtml.js.
export const PICTURE_HOST = 'https://popin.popinweddingdesigner.com'
